import { DragRow } from "@progress/kendo-angular-grid";
import { IGridFlavor } from "../../../interfaces/igrid-flavor.interface";
import { GridConfig } from "../../grid/grid-config.model";
import { GridFlavorBase } from "./grid-flavor-base";

export class RegularGridFlavor extends GridFlavorBase implements IGridFlavor {
    constructor() {
        super();
        this.addAdditionalButtons();
    }

    //VNEXT-1275: enable geocoding for "Project Description Table - Geography" grid in production Environmental Justice Data Call site ID 192
    public showGeocodeGrid(apiUrl: string, formFieldId: number): boolean {
        if (apiUrl.indexOf('.test.') < 0 && apiUrl.indexOf('.stage.') < 0 && apiUrl.indexOf('.sandbox.') < 0) {
            if (formFieldId == 12105) return true; 
            return false; //disable in production
        }
    }

    public gridCommandColumnWidth(): number {
        return 75;
    }

    public addAnyVirtualColumns(gridConfig: GridConfig): void {
        // NO OP
    }

    public canAddNewRow(): boolean {
        return true;
    }

    public usesButton(button: string, dataItem: any /*ignored*/): boolean {
        return this.gridCommandButtons.indexOf(button) > -1;
    }

    // There are no constraints on moving regular grid rows
    public cannotMoveRowMessage(row: DragRow): string {
        return null;
    }

    private addAdditionalButtons() {
        this.gridCommandButtons = this.gridCommandButtons.concat(['delete']);
    }
}
